export enum EGender {
    MALE = "male",
    FEMALE = "female",
    NON_BINARY = "non binary",
}